import { Event } from '../interfaces';
import { isAggregableEvent } from './isAggregableEvent';

export const getEventDate = (event: Event): string => {
  // In case of real MATCH events, the event is only created when theres at least two sub-events.
  // In case of not MATCH, but having sub_events we're using events grouping and created_at date should
  // come directly from the event itself.
  if (isAggregableEvent(event) && event.event_type_identifier.includes('_MATCH')) {
    // special case for legacy events
    if (!event.sub_events) {
      return event.captured_at;
    }

    // we're asssuming events are already sorted by captured_at date
    const dates = event.sub_events.map((se) => se.captured_at);
    return dates[1] ?? dates[0];
  }

  return event.captured_at;
};
